
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Msg,
Divider,
XButton
},
name: "login",
data () {
return {
title: '错误提示',
description: '',
icon: '',
redirect: '/',
buttons: [{
type: 'primary',
text: '返回首页',
link: '/'
}]
}
},
created(){

this.description = this.$route.query.msg
}
}



// WEBPACK FOOTER //
// ./src/components/Intercept.vue